import React, { useEffect, useState, useRef } from "react";
import { TbTreadmill } from "react-icons/tb";
import { IoSearch } from "react-icons/io5";
import "../styles/ExerciseManagement.css";
import GymTable from "../components/GymTable";
import axios from "axios";
import API_URL from "../config";
import { useAdmin } from "../contexts/AdminContext";
import Loading from "../components/Loading";

const ExerciseManagement = () => {
  const { admin } = useAdmin();
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [memberId, setMemberId] = useState("");
  const [userData, setUserData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSave = async () => {
    if (!memberId || !selectedFile) {
      alert("Please enter member ID and upload a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.patch(
        `${API_URL}/auth/${memberId}/${admin.branch}/exercisePlan`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Exercise plan uploaded successfully!");
      setSelectedFile(null);
    } catch (error) {
      alert("Failed to upload diet plan.");
    }
  };

  useEffect(() => {
    const fetchUsersByBranch = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/auth/branch/${admin?.branch}`
        );
        const sortedUsers = response.data.sort((a, b) => {
          return parseInt(a.memberId) - parseInt(b.memberId);
        });

        setUsers(sortedUsers);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersByBranch();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleMemberIdChange = async (e) => {
    const id = e.target.value;
    setMemberId(id);

    if (id) {
      try {
        const response = await axios.get(
          `${API_URL}/auth/${id}/${admin.branch}`
        );
        setUserData(response.data);
      } catch (error) {
        setUserData(null);
      }
    } else {
      setUserData(null);
    }
  };

  const filteredUsers = users.filter(
    (user) =>
      user.fullName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.memberId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.phoneNo.includes(searchTerm)
  );

  return (
    <div className="exerciseManagementContainer">
      <div className="exerciseManagementHeader">
        <div className="exerciseHeaderLeft">
          <TbTreadmill size={30} color="#ff0000" style={{ marginRight: 10 }} />
          <h2>Exercise Management</h2>
        </div>
      </div>
      <h3>Exercise Chart :</h3>
      <div className="userListInputMain" style={{ marginBottom: 20 }}>
        <div className="addUserListInputMain">
          <div className="addUserListInput">
            <label>Member ID</label>
            <input
              type="text"
              value={memberId}
              onChange={handleMemberIdChange}
            />
          </div>
          <div className="addUserListInput">
            <label>Name</label>
            <input type="text" value={userData?.fullName || ""} readOnly />
          </div>
        </div>
        <div className="addUserListInputMain">
          <div className="addUserListInput">
            <label>Email ID</label>
            <input type="text" value={userData?.email || ""} readOnly />
          </div>
          <div className="addUserListInput">
            <label>Phone no</label>
            <input type="text" value={userData?.phoneNo || ""} readOnly />
          </div>
        </div>
        <div className="addUserListInputMain">
          <div className="dietPlainDiv">
            <label>Membership Status</label>
            <div className="activeOrNot">
              <button>
                <div
                  style={{
                    backgroundColor:
                      new Date(userData?.renewalExpiryDate) < new Date() &&
                      "#ff0000",
                  }}
                ></div>
                {new Date(userData?.renewalExpiryDate) < new Date()
                  ? "Expired"
                  : `Active`}
              </button>
            </div>
          </div>
          <div className="dietPlainDiv">
            <label>Attach PDF (Add exercise plan chart)</label>
            <div className="addAttachment">
              <button onClick={handleButtonClick}>+</button>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept="application/pdf"
              />
            </div>
          </div>
        </div>
      </div>
      <button className="dietPlanSaveBtn" onClick={handleSave}>
        Save
      </button>

      <div className="dietUserPlanListed">
        <h3>List view with renewal status for quick scanning</h3>
        <div className="dietHeaderRight">
          <input
            placeholder="eg. Search by memberId, name, phone"
            onChange={handleSearchChange}
          />
          <div>
            <IoSearch />
          </div>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <GymTable
          data={filteredUsers}
          isEdit={true}
          from={"exerciseManagement"}
        />
      )}
    </div>
  );
};

export default ExerciseManagement;
